import styled from 'styled-components';

const Layer = styled('div')`
	position: fixed;
	left: 0;
	top: 0;
	z-index: 100;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

export { Layer };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DesktopDragPreview/styles.ts